import store from "@/store";
import {clone} from "@/utils/cloneUtil";
import {Slide} from "@/store/slides2Video/slides2VideoModels";
import {UPDATE_SLIDES} from "@/store/slides2Video/slides2VideoAction";


export const updateCurrentSlide = (newSlide:Slide) => {
    const currentSlideIndex=store.getters.getCurrentSlideIndex;
    const slidesClone=clone(store.getters.slides) as Slide[];
    for(const slide of slidesClone){
        if(currentSlideIndex+1===slide.order){
            slide.text=newSlide.text;
            slide.script=newSlide.script;
            slide.layout=newSlide.layout;
            slide.originalDocumentB64=newSlide.originalDocumentB64;
            slide.avatarBackground=newSlide.avatarBackground;
            slide.avatar=newSlide.avatar;
            slide.lang=newSlide.lang;
            slide.voice=newSlide.voice;
            slide.slideDescription=newSlide.slideDescription;
            slide.slideTitle=newSlide.slideTitle;
            slide.slideTemplate=newSlide.slideTemplate;
            slide.slideTheme=newSlide.slideTheme;
            slide.promptIllustrationGeneration=newSlide.promptIllustrationGeneration;
            slide.slideImageB64=newSlide.slideImageB64;
            slide.chunkVideoUrl=newSlide.chunkVideoUrl;
            slide.videoTimestampStart=newSlide.videoTimestampStart;
            slide.videoTimestampEnd=newSlide.videoTimestampEnd;
            slide.documentType=newSlide.documentType;
            slide.slideVideoUrl=newSlide.slideVideoUrl;
            break;
        }
    }
    store.dispatch(UPDATE_SLIDES,slidesClone)
}
